import { render } from "./IconCheckmarkStroke.vue?vue&type=template&id=6364870e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconCheckmarkStroke.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6364870e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6364870e', __exports__)) {
    api.reload('6364870e', __exports__)
  }
  
  module.hot.accept("./IconCheckmarkStroke.vue?vue&type=template&id=6364870e", () => {
    api.rerender('6364870e', render)
  })

}


export default __exports__